import React from "react";

const LIFESTYLE_PRESETS = [
  { key: "aging_in_place",     label: "Aging in place" },
  { key: "first_time_buyer",   label: "First-time Builder" },
  { key: "narrow_lot",         label: "Narrow lot" },
  { key: "multi_generational", label: "Multi-generational" },
  { key: "investor_rental",    label: "Investor / rental" },
];

/**
 * Lifestyle preset chips — quick filter shortcuts that map to underlying tags.
 * Clicking a chip applies/un-applies the preset and scrolls to the grid.
 */
export default function LifestyleStrip({ value, onChange, gridRef }) {
  return (
    <div className="mb-7" data-testid="lifestyle-strip">
      <div
        className="flex items-center gap-3 flex-wrap"
      >
        <span
          className="wn-label"
          style={{ color: "#8F3C23", whiteSpace: "nowrap" }}
        >
          Browse by lifestyle
        </span>
        <div className="flex flex-wrap gap-2">
          {LIFESTYLE_PRESETS.map((p) => {
            const active = value === p.key;
            return (
              <button
                key={p.key}
                onClick={() => {
                  onChange(active ? "" : p.key);
                  if (!active && gridRef?.current) {
                    setTimeout(
                      () =>
                        gridRef.current?.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        }),
                      120
                    );
                  }
                }}
                data-testid={`lifestyle-${p.key}`}
                style={{
                  padding: "5px 12px",
                  borderRadius: 999,
                  border: `1px solid ${active ? "#B14E2F" : "#D9D8E4"}`,
                  backgroundColor: active ? "#B14E2F" : "transparent",
                  color: active ? "#FBFAFD" : "#1B1F4B",
                  fontFamily: '"Nunito Sans", sans-serif',
                  fontWeight: 600,
                  fontSize: 12.5,
                  cursor: "pointer",
                  transition: "all 160ms ease",
                }}
              >
                {p.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
